/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.learning.center.user.progress.rpc.PlaylistProgressChirpService
 */
import * as References from './PlaylistProgressChirpService';
import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { registerQuery } from 'data-fetching-client/next';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.learning.center.user.progress.rpc.PlaylistProgressChirpService#getPlaylistProgressAggregation
 */
export const GET_PLAYLIST_PROGRESS_AGGREGATION_QUERY_FIELD_NAME = 'com_hubspot_learning_center_user_progress_rpc_PlaylistProgressChirpService_getPlaylistProgressAggregation';
export const GET_PLAYLIST_PROGRESS_AGGREGATION_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_PLAYLIST_PROGRESS_AGGREGATION_QUERY_FIELD_NAME,
  args: ['playlistId', 'request'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.getPlaylistProgressAggregationRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.learning.center.user.progress.rpc.PlaylistProgressChirpService#getPlaylistProgressForUsers
 */
export const GET_PLAYLIST_PROGRESS_FOR_USERS_QUERY_FIELD_NAME = 'com_hubspot_learning_center_user_progress_rpc_PlaylistProgressChirpService_getPlaylistProgressForUsers';
export const GET_PLAYLIST_PROGRESS_FOR_USERS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_PLAYLIST_PROGRESS_FOR_USERS_QUERY_FIELD_NAME,
  args: ['playlistId', 'userIds'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.getPlaylistProgressForUsersRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.learning.center.user.progress.rpc.PlaylistProgressChirpService#getPlaylistProgressPaginated
 */
export const GET_PLAYLIST_PROGRESS_PAGINATED_QUERY_FIELD_NAME = 'com_hubspot_learning_center_user_progress_rpc_PlaylistProgressChirpService_getPlaylistProgressPaginated';
export const GET_PLAYLIST_PROGRESS_PAGINATED_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_PLAYLIST_PROGRESS_PAGINATED_QUERY_FIELD_NAME,
  args: ['playlist', 'limit', 'pageLength', 'offset'],
  fetcher(request, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.getPlaylistProgressPaginatedRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});